var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.affiliations,"label":_vm.labelText,"clearable":"","dense":"","outlined":"","hide-details":""},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedAffiliation),callback:function ($$v) {_vm.selectedAffiliation=$$v},expression:"selectedAffiliation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }